import type { PatentProfile as ServerPatentProfile } from '@/infrastructure/api-functions/core-drafting-api/patent-profile-by-ids-api';

export interface SimpleFamilyItem {
    /**
     * 专利ID
     */
    patentId: string;
    /**
     * 专利号
     */
    pn: string;
}

export interface PatentImageInfo {
    /**
     * 图片标签
     */
    labels: string[];
    /**
     * 是否已提取
     */
    extracted: boolean;
    /**
     * 专利ID
     */
    patent_id: string;
    /**
     * 图片标题代码
     */
    fig_title_code: string;
    /**
     * 缩略图URL (240px)
     */
    fulltext_image240_url: string;
    /**
     * 官方尺寸
     */
    official_size: string;
    /**
     * 图片ID
     */
    image_id: string;
    /**
     * 图片来源
     */
    image_from: string;
    /**
     * 存储路径
     */
    storage_path: string;
    /**
     * 源图片类型
     */
    source_image_type: string;
    /**
     * 图片类型
     */
    image_type: string;
    /**
     * 是否已提取
     */
    is_extracted: boolean;
}

export interface PatentProfile {
    /**
     * 专利名称
     */
    title: string;
    /**
     * 专利号
     */
    patentNo: string;
    /**
     * 专利 id
     */
    patentId: string;
    /**
     * 公开日
     */
    apd: string;
    /**
     * 公开日
     */
    pbd: string;
    /**
     * 过期日
     */
    exdt: string;
    /**
     * 申请人
     */
    ancs: string[];
    /**
     * 法律状态
     */
    legalStatus: number[];
    /**
     * 简单法律状态
     */
    simpleLegalStatus: number;
    /**
     * 家族号
     */
    familyId: string;
    /**
     * 摘要
     */
    abst: string;
    pdfImages: PatentImageInfo[];
    /**
     * 发明人
     */
    in: string[];
    /**
     * 简单家族列表
     */
    simpleFamilyList?: SimpleFamilyItem[];
}
/**
 * 专利信息服务
 * @description 获取专利信息, title, No., patentId
 */
export interface PatentProfileService {
    /**
     * 获取专利信息
     */
    getPatentProfile(patentId: string): Promise<PatentProfile>;
    /**
     * 获取专利信息
     */
    getPatentProfiles(patentIds: string[]): Promise<PatentProfile[]>;

    /**
     * 获取专利信息（包含家族信息）
     */
    getPatentProfileWithFamily(patentId: string): Promise<PatentProfile>;

    /**
     * 批量获取专利信息（包含家族信息）
     */
    getPatentProfilesWithFamily(patentIds: string[]): Promise<PatentProfile[]>;

    /**
     * 关键词模糊查询专利
     */
    getPatentAutocomplete(keyword: string): Promise<PatentProfile[]>;

    /**
     * 转换专利信息
     */
    convertPatentProfile(data: Partial<ServerPatentProfile>, lang?: string): PatentProfile;
}

export const PatentProfileService = Symbol.for('PatentProfileService');
